import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
// import List from '@mui/material/List';
import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Toolbar from '@mui/material/Toolbar';
// import Collapse from '@mui/material/Collapse';
// import ListItem from '@mui/material/ListItem';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
// import SearchIcon from '@mui/icons-material/Search';
import SvgFooter from '../resources/RinuFooter.svg';
// import Search from '../resources/Group 51.svg';
// import Client from '../resources/Group 4.svg';
// import Shoping from '../resources/Group 131.svg';
// import ListItemText from '@mui/material/ListItemText';
// import ExpandMore from '@mui/icons-material/ExpandMore';
// import ExpandLess from '@mui/icons-material/ExpandLess';
// import ListItemButton from '@mui/material/ListItemButton';
import TranslateIcon from '@mui/icons-material/Translate';
// import ShoppingCartSharpIcon from '@mui/icons-material/ShoppingCartSharp';
// import PersonOutlineSharpIcon from '@mui/icons-material/PersonOutlineSharp';
import RecursiveMenu from './RecursiveMenu';
import Modal from '../components/Modal';
import Typography from '@mui/material/Typography';
import { Menu, MenuItem } from '@mui/material';
import {
    useDispatch
    ,
    useSelector
} from 'react-redux';
import { setLanguage } from '../app/language/Language';
import { useTranslation } from '../hook/Translation';
import HeaderLanguageSwitcher from './comp/Header-Language-Switcher';
// import { openCart } from '../app/cart/Cart';

export default function Header() {
    const { t } = useTranslation();
    const { language } = useSelector(state => state.language);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedLanguage, setSelectedLanguage] = useState('en');

    const drawerWidth = '80%';
    const navItems = [
        {
            name: 'Skin',
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/EMSCULPT_Menu_Banner.png`,
            collapsible: true,
            submenu: [
                {
                    // name: 'HYDRATE, LIFT & GLOW',
                    // customStyle: { gridColumnStart: 1, gridColumnEnd: 3, gridRowStart: 1, gridRowEnd: 4 },
                    customStyle: { gridColumnStart: 1, gridColumnEnd: 3, gridRowStart: 1, gridRowEnd: 7 },

                    collapsible: null,
                    menu: [
                        { name: 'EMFACE', link: 'skin/emface-facial-muscle-lift-tone' },
                        { name: 'EMFUSION', link: 'skin/emfusion-trans-dermal-infusion-facial' },
                        { name: 'EXION Fractional Microneedling RF', link: 'skin/rf-collagen-induction' },
                        { name: 'EXION Clear RF', link: 'skin/exion-clear-rf' },
                        { name: 'EXION Face', link: 'skin/exion-face-applicator' },
                        { name: t('menu.hairRemoval'), link: 'skin/targeted-laser-skin-therapies' },
                        { name: t('menu.rosecave'), link: 'skin/clarity/clarity-ii-rosacea-treatment' },
                        { name: t('menu.pigmentation'), link: 'skin/clarity/clarity-ii-pigmentation-treatments' },
                        { name: t('menu.skinRegen'), link: 'skin/clarity/clarity-ii-laser-genesis–style-rejuvenation' },

                        // { name: 'EMFACE', link: 'skin/emface-facial-muscle-lift-tone' },
                        // { name: 'EMFUSION', link: 'skin/emface-facial-muscle-lift-tone' },
                        // { name: 'EMFACE Lift', link: 'skin/emface-facial-muscle-lift-tone' },
                        // { name: 'EXION Micro-needling', link: 'skin/rf-collagen-induction' },
                        // { name: 'EXION Body Infusion', link: 'skin/emfusion-trans-dermal-infusion-facial' },
                        // { name: 'EXION Face Targeted Tightening', link: 'skin/needle-free-rf-face-tightening' },
                        // { name: 'EXION RF Lift', link: 'body/exion-rf-body-skin-tightening' },
                        // { name: 'EMTONE Face Firm', link: 'skin/emface-facial-muscle-lift-tone' },
                    ]
                },

                // {
                //     // name: 'ALMA LASER SOLUTIONS',
                //     customStyle: { gridColumnStart: 4, gridColumnEnd: 7, gridRowStart: 1, gridRowEnd: 7 },
                //     collapsible: null,
                //     menu: [

                //         // { name: 'Hybrid Laser + Serum', link: 'skin/hybrid-laser-serum-infusion' },
                //         // { name: 'Vascular Treatments', link: 'skin/clarity/clarity-ii-vascular-treatments' },
                //         // { name: 'Vaginal tightening treatment', link: 'skin/alma/AlmaVaginalTightening' },
                //         // { name: 'Infections and yeast issues', link: '' },
                //         // { name: 'Post-menopause intimate', link: 'skin/alma/AlmaPostMenopauseConditions' },
                //         // { name: 'Intimate area brightening', link: '' },
                //         // { name: 'Laser labiaplasty', link: 'skin/alma/AlmaLaserLabiaplasty' },
                //     ]
                // },
                {
                    // name: 'CLARITY II',
                    customStyle: { gridColumnStart: 4, gridColumnEnd: 7, gridRowStart: 1, gridRowEnd: 7 },
                    collapsible: null,
                    menu: [
                        // { name: 'Hair Removal', link: 'skin/clarity/clarity-ii-vascular-treatments' },
                        // { name: 'Rosacea treatment', link: 'skin/clarity/clarity-ii-rosacea-treatment' },
                        // { name: 'Pigmentation and dark spots', link: 'skin/clarity/clarity-ii-pigmentation-treatments' },
                        // { name: 'Laser Genesis skin rejuvenation', link: 'skin/clarity/clarity-ii-laser-genesis–style-rejuvenation' },
                        // { name: 'Fungal nail treatment', link: 'skin/clarity/clarity-ii-nail-fungus-treatment' },
                        // { name: 'Fractional C02 Resurfacing', link: 'skin/fractional-co2-resurfacing' },
                        // { name: 'Hybrid Laser Erbium Glass', link: 'skin/hybrid-laser-erbium-glass' },

                        { name: t('menu.nailFungus'), link: 'skin/clarity/clarity-ii-nail-fungus-treatment' },
                        { name: t('menu.vascularProblems'), link: 'skin/clarity/clarity-ii-vascular-treatments' },
                        // { name: 'Stimulimi i Kolagjenit', link: '' },
                        { name: 'FRACTIONAL CO₂ RESURFACING', link: 'skin/fractional-co2-resurfacing' },
                        { name: 'ERBIUM GLASS SOFTLIFT', link: 'skin/hybrid-laser-erbium-glass' },
                    ]
                },
            ]
        },
        {
            name: 'Body',
            imageUrl: `${process.env.REACT_APP_SITE_URL}/images/2025/12/EMSCULPT_Menu_Banner_2.png`,
            collapsible: true,
            submenu: [
                {
                    name: 'TRAJTIMET',
                    customStyle: { gridColumnStart: 1, gridColumnEnd: 3, gridRowStart: 1, gridRowEnd: 7 },
                    collapsible: null,
                    menu: [
                        { name: 'EMSCULPT Neo', link: 'body/emsculpt-neo-muscle-build-and-fat-reduction' },
                        { name: 'EMTONE', link: 'body/emtone-cellulite-smoothing' },
                        { name: 'EMSELLA', link: 'body/emsculpt-neo-muscle-build-and-fat-reduction-one' },
                        { name: 'EMFEMME 360°', link: 'body/female-intimate-wellness-one' },
                        { name: 'EXION Body', link: 'body/exion-rf-body-skin-tightening' },
                    ]
                },
                {
                    name: 'MASAZHET',
                    customStyle: { gridColumnStart: 4, gridColumnEnd: 7, gridRowStart: 1, gridRowEnd: 7 },
                    collapsible: null,
                    menu: [
                        // { name: 'RINU Ritual', link: 'the-rinu-ritual' },
                        // { name: 'Elemental Alchemy', link: 'elemental-alchemy' },
                        // { name: 'Stillstone Release', link: 'still-stone-release' },
                        // { name: 'Inner Sculpt', link: 'inner-sculpt' },
                        // { name: 'The deep rewire', link: 'the-deep-rewire' },
                        // { name: 'Strech and Spirit', link: 'stretch-and-spirit' },
                        // { name: 'Essence of Two', link: 'essence-of-two' },
                        // { name: 'Womb and Whisper', link: 'womb-and-whisper' },
                        { name: "RINU RITUAL", link: 'the-rinu-ritual' },
                        { name: "St.Barth ChillOut", link: 'elemental-alchemy' },
                        { name: "Deep Tissue", link: 'still-stone-release' },
                        // { name: "Fytyrë dhe Dekolte", link: 'inner-sculpt' },
                        { name: "Aroma Therapy", link: 'the-deep-rewire' },
                        { name: "Cupping", link: 'stretch-and-spirit' },
                        { name: "Hot Stone", link: 'essence-of-two' },
                        { name: "Fytyrë dhe Dekolte", link: 'face-decollete' }
                    ]
                }
            ]

        },
        // {
        //     name: 'Mind',
        //     collapsible: true,
        //     submenu: [
        //         {
        //             name: 'TREATMENTS',
        //             customStyle: { gridColumnStart: 1, gridColumnEnd: 3, gridRowStart: 1, gridRowEnd: 7 },
        //             collapsible: null,
        //             menu: [
        //                 { name: 'Exomind Neuro Protocol', link: 'mind/exomind' },
        //                 { name: 'Cellular Reset', link: '' },
        //                 { name: 'Longevity Plan', link: '' },
        //             ]
        //         },
        //         {
        //             name: 'BLOG',
        //             customStyle: { gridColumnStart: 4, gridColumnEnd: 7, gridRowStart: 1, gridRowEnd: 7 },
        //             collapsible: null,
        //             menu: [
        //                 { name: 'Laser lorem ', link: '/blogs' },
        //                 { name: 'Dolor Laser Solutions', link: '/' },
        //             ]
        //         }
        //     ]

        // },
        { name: 'Mind', collapsible: false, link: '/mind/exomind' },
        { name: 'Nail Bar', collapsible: false, link: '/nail-bar' },
        { name: 'Blogs', collapsible: false, link: '/blogs' },
        // { name: 'Treatments', collapsible: false, link: '/treatments' },
        // { name: 'Programs', collapsible: false, link: '/programs' },
        // { name: 'Shop', collapsible: false, link: '/shop' },
        // { name: 'About', collapsible: false, link: '/contact' },
    ];

    const languages = [
        { code: 'eng', label: 'ENG' },
        { code: 'alb', label: 'ALB' },
    ];

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const dispatch = useDispatch();

    const handleLanguageChange = (code) => {
        setSelectedLanguage(code);
        dispatch(setLanguage(code))
        handleClose();
        // You can also trigger i18n language change here if using react-i18next
        // i18n.changeLanguage(code);
    };

    const [mobileOpen, setMobileOpen] = React.useState(false);
    // const [anchorEl, setAnchorEl] = React.useState(null);
    const [activeMenu, setActiveMenu] = React.useState(null); // Track the active menu for hover submenu
    // const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showHeader, setShowHeader] = useState(true);
    const lastScrollY = useRef(0);

    const [openCollapses, setOpenCollapses] = useState({}); // track which collapses are open

    const handleToggleCollapse = (itemName) => {
        setOpenCollapses((prev) => ({
            ...prev,
            [itemName]: !prev[itemName],
        }));
    };

    const handleDrawerToggle = () => {
        setMobileOpen((prevState) => !prevState);
    };

    // const boxRef = useRef();  // Ref for the Box container
    // const [boxHeight, setBoxHeight] = useState(0);

    // useEffect(() => {
    //     // Ensure boxRef is set after the component renders
    //     if (boxRef.current) {
    //         setBoxHeight(boxRef.current.offsetHeight);  // Get the height of the Box element
    //     }
    // }, [activeMenu]);

    const drawer = (
        <Box sx={{ textAlign: 'center' }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {/* <Box component={'img'} src={SvgFooter} width={'80%'} marginY={2} sx={{ objectFit: 'cover' }} /> */}
            </Box>
            <Divider />
            <RecursiveMenu
                items={navItems}
                openCollapses={openCollapses}
                handleToggleCollapse={handleToggleCollapse}
                handleDrawerToggle={handleDrawerToggle}
            />
        </Box>
    );

    // const handleCloseCart = () => {
    //     dispatch(openCart(true))
    // }
    const modalRef = useRef(null);
    const buttonRef = useRef(null);

    // Function to handle mouse enter on button
    const handleMouseEnter = (event, item) => {
        setActiveMenu(item);
        setOpenModal(true);
    };

    // Function to handle mouse leave on button
    const handleMouseLeave = () => {
        // setActiveMenu(null);
        setOpenModal(false);
    };

    // Function to handle mouse enter on modal
    const handleModalMouseEnter = () => {
        setOpenModal(true);
    };

    // Function to handle mouse leave on modal
    const handleModalMouseLeave = () => {
        if (!buttonRef.current || !buttonRef.current.contains(document.activeElement)) {
            setOpenModal(false);
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = Math.max(window.scrollY, 0);

            if (currentScrollY === 0) {
                setShowHeader(true);
                lastScrollY.current = currentScrollY;
                return;
            }

            if (currentScrollY > lastScrollY.current) {
                setShowHeader(false);
                setOpenModal(false);
            } else if (currentScrollY < lastScrollY.current) {
                setShowHeader(true);
            }

            lastScrollY.current = currentScrollY;
        };

        lastScrollY.current = Math.max(window.scrollY, 0);
        window.addEventListener('scroll', handleScroll, { passive: true });

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <Box sx={{ display: 'flex', minHeight: { xs: '64px', md: '90px' } }}>
            <AppBar component="nav" position='fixed' sx={{ backgroundColor: '#FFF', boxShadow: 2, '.MuiToolbar-root': { minHeight: { xs: '64px', md: '90px' } }, transform: showHeader ? 'translateY(0)' : 'translateY(-100%)', transition: 'transform 200ms ease-in-out', zIndex: 999 }}>
                <Toolbar>
                    <Grid size={{ lg: 0, xs: 'auto' }} sx={{ display: { lg: 'none', xs: 'flex' } }}>
                        <Box>
                            <IconButton color="inherit" aria-label="open drawer" edge="start" onClick={handleDrawerToggle} sx={{ mr: 2, display: { lg: 'none' } }}>
                                <MenuIcon htmlColor='#1E353D' />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid container sx={{ width: '100%' }} spacing={{ lg: 0, xs: 2 }} alignItems={'center'}>
                        {/* Menu */}
                        <Grid size={4} sx={{ display: { xs: 'none', lg: 'flex' } }}>
                            <Box sx={{ display: { xs: 'none', sm: 'flex' }, height: '100%', alignItems: 'center' }}>
                                {navItems.map((item, index) => (
                                    <Button
                                        key={index}
                                        LinkComponent={Link}
                                        to={item?.link}
                                        onMouseEnter={item?.collapsible === true ? (e) => handleMouseEnter(e, item) : undefined}
                                        onMouseLeave={item?.collapsible === true ? (e) => handleMouseLeave() : undefined}
                                        sx={{ color: '#1E353D', fontSize: '1rem', fontWeight: 'bold' }}
                                    >
                                        {item.name}
                                    </Button>
                                ))}

                            </Box>
                        </Grid>
                        <Grid size={{ lg: 4, sm: 8, xs: 11 }} height={1} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                            <Box
                                component={Link}
                                to="/"
                                sx={{ display: { lg: 'flex', xs: 'flex' }, justifyContent: 'center', alignItems: 'center' }}>
                                <Box component={'img'} src={SvgFooter} height={{ lg: '30px', xs: '20px' }} sx={{ objectFit: 'cover' }} />
                            </Box>
                        </Grid>
                        <Box sx={{ position: 'absolute', top: '50%', right: { lg: 30, xs: 10 }, transform: 'translateY(-50%)' }}>
                             <HeaderLanguageSwitcher />
                            {/* {
                                languages.map((lang) => (
                                    <Button
                                        sx={{ color: 'text.secondary' }}
                                        key={lang.code}
                                        selected={lang.code === selectedLanguage}
                                        onClick={() => handleLanguageChange(lang.code)}
                                        disabled={language === lang.code}
                                    >
                                        {lang.label}
                                    </Button>
                                ))
                            }
                            <Menu
                                anchorEl={anchorEl}
                                open={Boolean(anchorEl)}
                                onClose={handleClose}
                            >
                                {languages.map((lang) => (
                                    <MenuItem
                                        sx={{ color: 'text.secondary' }}
                                        key={lang.code}
                                        selected={lang.code === selectedLanguage}
                                        onClick={() => handleLanguageChange(lang.code)}
                                        disabled={language === lang.code}
                                    >
                                        {lang.label}
                                    </MenuItem>
                                ))}
                            </Menu> */}
                        </Box>
                        <Grid size={{ lg: 4, xs: 'auto' }} sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                            <Grid container spacing={2} alignItems={'center'}>
                                <Grid size={'auto'}>
                                    <Box display={'flex'} alignItems={'center'}>
                                    </Box>
                                    <Box display={{lg: 'flex', xs: 'none'}}>
                                        <HeaderLanguageSwitcher />
                                    </Box>
                                    {/* {
                                languages.map((lang) => (
                                    <Button
                                        sx={{ color: 'text.secondary' }}
                                        key={lang.code}
                                        selected={lang.code === selectedLanguage}
                                        onClick={() => handleLanguageChange(lang.code)}
                                        disabled={language === lang.code}
                                    >
                                        {lang.label}
                                    </Button>
                                ))
                            } */}
                                    {/* <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
                                        {languages.map((lang) => (
                                            <MenuItem
                                                sx={{ color: 'text.secondary' }}
                                                key={lang.code}
                                                selected={lang.code === selectedLanguage}
                                                onClick={() => handleLanguageChange(lang.code)}
                                            >
                                                {lang.label}
                                            </MenuItem>
                                        ))}
                                    </Menu> */}
                                </Grid>
                                <Grid size={'auto'} sx={{ display: { lg: 'flex', xs: 'none' } }}>
                                    <Box display={'flex'} gap={2}>
                                        {/* <Button variant='outlined' LinkComponent={Link} to="/login" sx={{ background: 'transparent', borderColor: '#1E353D', color: '#1E353D', borderRadius: 0, borderWidth: '2px', fontSize: '1.125rem', width: '103px', textTransform: 'none', fontWeight: 'bold' }}>
                                            Rinu
                                        </Button> */}
                                        <Button variant='contained' LinkComponent={Link} to={`https://wa.me/+383049909090?text=${encodeURIComponent("Pershendetje, dua të bëj një rezervimë")}`} sx={{ background: '#1E353D', borderRadius: 0, borderWidth: '2px', color: '#FFF', fontSize: '1.125rem', width: '166px', textTransform: 'none', boxShadow: 'none' }}>
                                            {t('book_now')}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Toolbar>
            </AppBar>
            <nav>
                <Drawer
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{ keepMounted: true }}
                    sx={{ display: { xs: 'block', lg: 'none' }, '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth } }}>
                    {drawer}
                </Drawer>
            </nav>
            <Modal state={openModal} setState={setOpenModal}>
                <Box bgcolor={'#FFF'} position={'fixed'} top={90} left={0} width={1} minHeight={'450px'} maxHeight={'500px'} overflow={'hidden'} ref={modalRef} onMouseEnter={handleModalMouseEnter} onMouseLeave={handleModalMouseLeave}>
                    <Grid container spacing={4} height={1}>
                        <Grid size={6} paddingTop={'40px'} paddingBottom={'40px'}>
                            <Box marginX={'auto'} width={'90%'} display={'grid'} rowGap={'50px'} gridTemplateColumns={'1fr 1fr 1fr 1fr 1fr 1fr'} gridTemplateRows={'1fr 1fr 1fr 1fr 1fr 1fr'}>
                                {
                                    activeMenu?.submenu.map((data, index) => (
                                        <Box key={index} sx={data.customStyle}>
                                            <Grid container spacing={2}>
                                                <Grid size={12}>
                                                    <Typography variant="body1" className='dColor' fontWeight={'bold'} fontSize={'1rem'}>{data.name}</Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <Grid container spacing={1}>
                                                        {
                                                            data?.menu?.map((item, itemIndex) => (
                                                                <Grid key={itemIndex} size={12}>
                                                                    <Typography component={Link} to={item.link} variant="body1" className='dColor' fontSize={'1rem'}>{item.name}</Typography>
                                                                </Grid>
                                                            ))
                                                        }
                                                    </Grid>
                                                </Grid>
                                            </Grid>

                                        </Box>
                                    ))
                                }
                            </Box>
                        </Grid>
                        <Grid size={6} position={'relative'}>
                            <Box width={1} height={'100%'}>
                                <Box component={'img'} src={activeMenu?.imageUrl} width={1} height={1} className='fitCover' />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </Box >
    )
};
